export default __webpack_public_path__ + "static/media/home-cafe-img-01.bb781db1.jpg";